import React from 'react';
import { createIcon } from './create-icon';
import './icon-caret-down.scss';

export const IconCaretDown = createIcon(<div className="icon-caret-down-primary" />);
export const IconCaretDownSecondary = createIcon(<div className="icon-caret-down-secondary" />);
export const IconCaretDownWhite = createIcon(<div className="icon-caret-down-white" />);
